class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    
    // Don't auto-select a variant - let user choose
  }

  onVariantChange(e) {
    const { isCombinedProduct, targetUrl } = this.combinedListingCheck(e);

    // Don't disable button immediately - let it be managed by our custom logic
    // this.toggleAddButton(true, '', false);

    if (isCombinedProduct) {
      this.fetchProductSection(targetUrl);
      return;  // Stop execution if false
    }

    this.updateOptions();
    this.updateMasterId();
    this.updatePickupAvailability();
    this.updateInventoryStatus();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      // Don't set as unavailable if user is still selecting options
      // Keep price visible during selection process
      const price = document.getElementById(`price-${this.dataset.section}`);
      if (price) price.classList.remove('hidden');
      
      const price_BuyBar = document.getElementById(`price-${this.dataset.section}-product-buy-bar`);
      if (price_BuyBar) price_BuyBar.classList.remove('hidden');
    } else {
      // Write variant id before media updates so cart never depends on slider success
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      try {
        this.updateMedia();
      } catch (err) {
        console.error(err);
      }
      // Enable button when variant is fully selected
      this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
    }
  }

  combinedListingCheck(e) {
    const currentUrl = window.location.pathname;
    const targetUrl = e.target.dataset.productUrl;
    let isCombinedProduct = false;

    if (targetUrl != undefined && currentUrl != targetUrl) {
      isCombinedProduct = true;
    }

    return { isCombinedProduct, targetUrl };
  }

  async fetchProductSection(newProductUrl) {
    const productElement = this.closest('.main-product');
    const productSectionId = this.dataset.section;
    let params = `section_id=${productSectionId}&`;

    const selectedOptionValues = Array.from(this.querySelectorAll('fieldset input:checked')).map((element) => element.dataset.optionValueId).join(',');
      params += `option_values=${selectedOptionValues}`;

    fetch(`${newProductUrl}?${params}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        productElement.innerHTML = html.querySelector('.main-product').innerHTML;
        window.history.replaceState({ }, '', `${newProductUrl}`);
      });
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGridySlider = document.getElementById(`slider-${this.dataset.section}`);
    const thumbnailsGridySlider = document.getElementById(`thumbnail-slider-${this.dataset.section}`);
    
    if (mediaGridySlider) {
      mediaGridySlider.scrollToSlideByID(
        `item-${this.currentVariant.featured_media.id}`
      );
    }
    
    if (thumbnailsGridySlider) {
      thumbnailsGridySlider.scrollToSlideByID(`thumbnail-item-${this.currentVariant.featured_media.id}`)
    }

    const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
    const isGrid = mediaGridySlider?.dataset.desktopEnabled === 'false';
    if (isDesktop && isGrid) {
      document.getElementById(`item-${this.currentVariant.featured_media.id}`)?.scrollIntoView();
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #product-form-${this.dataset.section}-product-buy-bar`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    this.updateInstallmentTitleAmount();
  }

  updateInstallmentTitleAmount() {
    if (!this.currentVariant) return;

    document.querySelectorAll('.summary-title--installments').forEach((row) => {
      const installments = Number(row.dataset.installments) || 0;
      const amountEl = row.querySelector('[data-installment-title-amount]');
      if (!installments || !amountEl || typeof Woolman?.Utils?.formatMoney !== 'function') return;

      amountEl.textContent = Woolman.Utils.formatMoney(Math.round(this.currentVariant.price / installments));
    });

    document.querySelectorAll('[data-payment-options] [data-payment-option]').forEach((option) => {
      const installments = Number(option.dataset.installments) || 0;
      const amountEl = option.querySelector('[data-payment-amount]');
      if (!installments || !amountEl || typeof Woolman?.Utils?.formatMoney !== 'function') return;
      amountEl.textContent = Woolman.Utils.formatMoney(Math.round(this.currentVariant.price / installments));
    });
  }

  updateVariantStatuses() {
    const checkedOption = this.querySelector(':checked');
    if (!checkedOption) return; // Exit if nothing is selected
    
    const selectedOptionOneVariants = this.variantData.filter(variant => checkedOption.value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  updateInventoryStatus() {
    this.productInventoryNode = document.querySelector('[data-product-inventory]');

    if (!this.productInventoryNode || !window.inventories || !window.inventories[this.dataset.productId]) return;

    this.inventoryThreshold = parseInt(this.productInventoryNode.dataset.threshold);
    this.showQuantityInStock = this.productInventoryNode.dataset.showQuantityInStock;

    const variantInventoryObject = window.inventories[this.dataset.productId][this.currentVariant?.id];

    if (!this.currentVariant || !this.currentVariant.inventory_management) {
      this.toggleInventoryQuantity(false);
      this.toggleIncomingInventory(false);

      return;
    }

    if (this.currentVariant.inventory_management === 'shopify') {
      if (variantInventoryObject.quantity <= 0 && variantInventoryObject.incoming === 'true' && variantInventoryObject.quantity < this.inventoryThreshold) {
        this.toggleInventoryQuantity(false);
        this.toggleIncomingInventory(true, variantInventoryObject.next_incoming_date);
      } else {
        this.toggleInventoryQuantity(true, variantInventoryObject.quantity);
        this.toggleIncomingInventory(false);
      }
    }
  }

  toggleInventoryQuantity(show, quantity) {
    if (show === false) {
      this.productInventoryNode.classList.add('hide');
      return;
    }

    this.productInventoryNode.classList.remove('inventory-status--in-stock', 'inventory-status--low', 'inventory-status--sold-out', 'inventory-status--sold-out-continue-selling');

    if (this.currentVariant && this.currentVariant.available && parseInt(quantity) <= parseInt(this.inventoryThreshold) && parseInt(quantity) > 0) {
      this.productInventoryNode.classList.add('inventory-status--low');
      if (this.showQuantityInStock === 'true') {
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.few_left_with_quantity.replace('[quantity]', quantity);
      } else {
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.few_left;
      }
    } else if (this.currentVariant && this.currentVariant.available && parseInt(quantity) > parseInt(this.inventoryThreshold)) {
      this.productInventoryNode.classList.add('inventory-status--in-stock');
      if (this.showQuantityInStock === 'true') {
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.in_stock_with_quantity.replace('[quantity]', quantity);
      } else {
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.in_stock;
      }
    } else if (this.currentVariant && this.currentVariant.available && parseInt(quantity) < 1) {
      this.productInventoryNode.classList.add('inventory-status--sold-out-continue-selling');
      this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.out_of_stock_continue_selling;
    } else {
      this.productInventoryNode.classList.add('inventory-status--sold-out');
      this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.out_of_stock;
    }

    this.productInventoryNode.classList.remove('hide');
  }

  toggleIncomingInventory(show, date) {
    const incomingInventoryNode = document.querySelector('[data-incoming-inventory]');
    if (!incomingInventoryNode) return;

    if (show == false && incomingInventoryNode) {
      incomingInventoryNode.classList.add('hide');

      return;
    }

    let string = !date ?
      window.variantStrings.inventory.waiting_for_stock : 
      window.variantStrings.inventory.will_be_in_stock_after.replace('[date]', date);

    incomingInventoryNode.classList.remove('hide');
    incomingInventoryNode.firstElementChild.textContent = string;
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const destinationBuyBarInfo = document.getElementById(
          `buy-bar-info-${this.dataset.section}`
        );
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const buyBarInfoSource = html.getElementById(`buy-bar-info-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;
        if (source && destinationBuyBarInfo) destinationBuyBarInfo.innerHTML = buyBarInfoSource.innerHTML;

        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const multiplyButtons = productForm.querySelectorAll('.btn--add-multiplier');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
      if (multiplyButtons) {
        multiplyButtons.forEach(button => {
          button.disabled = true;
        });
      }
    } else {
      addButton.removeAttribute('disabled');
      if (this.dataset.isPreorder == 'true') {
        addButtonText.textContent = window.variantStrings.preOrder;
      } else {
        addButtonText.textContent = window.variantStrings.addToCart;
      }
      if (multiplyButtons) {
        multiplyButtons.forEach(button => {
          button.removeAttribute('disabled');
        });
      }
    }

    const productForm_BuyBar = document.getElementById(
      `product-form-${this.dataset.section}-product-buy-bar`
    );
    if (productForm_BuyBar) {
      const addButton_BuyBar = productForm_BuyBar.querySelector('[name="add"]');
      const addButtonText_BuyBar = productForm_BuyBar.querySelector(
        '[name="add"] > span'
      );

      if (disable) {
        addButton_BuyBar.setAttribute("disabled", "disabled");
        if (text) addButtonText_BuyBar.textContent = text;
      } else {
        addButton_BuyBar.removeAttribute("disabled");
        if (this.dataset.isPreorder == "true") {
          addButtonText_BuyBar.textContent = window.variantStrings.preOrder;
        } else {
          addButtonText_BuyBar.textContent = window.variantStrings.addToCart;
        }
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');

    const button_BuyBar = document.getElementById(
      `product-form-${this.dataset.section}-product-buy-bar`
    );
    const addButton_BuyBar = button_BuyBar.querySelector('[name="add"]');
    const addButtonText_BuyBar = button_BuyBar.querySelector(
      '[name="add"] > span'
    );
    const price_BuyBar = document.getElementById(
      `price-${this.dataset.section}-product-buy-bar`
    );
    if (!addButton_BuyBar) return;
    addButtonText_BuyBar.textContent = window.variantStrings.unavailable;
    if (price_BuyBar) price_BuyBar.classList.add("hidden");
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      const checkedInput = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
      return checkedInput ? checkedInput.value : null;
    });

    this.updateLegends();
  }

  updateLegends() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    fieldsets.forEach((fieldset) => {
      const legend = fieldset.querySelector('legend [data-variant-legend]');
      const selectedOption = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
      if (legend && selectedOption) {
        legend.textContent = selectedOption.getAttribute('value');
      }
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductBuyBar extends HTMLElement {
  constructor() {
    "use strict";
    super();

    let classes = { hide: "hide" };
    let mainProductForm = document.querySelector(".product-form");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Main form in view -> Hide sticky bar
            this.classList.add(classes.hide);
          } else {
            // Main form out of view -> Show sticky bar
            this.classList.remove(classes.hide);
          }
        });
      },
      { threshold: 0.25 }
    );

    observer.observe(mainProductForm);
  }
}
customElements.define("product-buy-bar", ProductBuyBar);

class UpsellCard extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector('select');
    this.image = this.querySelector('.card-media img');

    if (this.select) {
      this.select.addEventListener('change', (event) => {
        const selectedOption = event.target.options[event.target.selectedIndex];
        const newImgSrc = selectedOption.getAttribute('data-variant-img-src');
        if (newImgSrc) { this.updateImage(newImgSrc) }
      });
    }
  }

  updateImage(newImgSrc) {
    if (this.image) {
      this.image.src = newImgSrc;
    }
  }
}

customElements.define('upsell-card', UpsellCard);
// Product Tabs Functionality
document.addEventListener('DOMContentLoaded', function() {
  const tabContainers = document.querySelectorAll('.product-tabs');
  
  tabContainers.forEach(container => {
    const buttons = container.querySelectorAll('.product-tabs__button');
    const panels = container.querySelectorAll('.product-tabs__panel');
    
    buttons.forEach(button => {
      button.addEventListener('click', function() {
        const tabNumber = this.getAttribute('data-tab');
        
        // Remove active class from all buttons and panels
        buttons.forEach(btn => btn.classList.remove('active'));
        panels.forEach(panel => panel.classList.remove('active'));
        
        // Add active class to clicked button and corresponding panel
        this.classList.add('active');
        const activePanel = container.querySelector(`[data-tab-panel="${tabNumber}"]`);
        if (activePanel) {
          activePanel.classList.add('active');
        }
      });
    });
  });
});

// Two Column Content - Size Guide Modal Trigger
document.addEventListener('DOMContentLoaded', function() {
  // Get device type
  const device = window.innerWidth >= 750 ? 'desktop' : 'mobile';
  
  // Get size guide URLs from the existing script (defined in product-template.liquid)
  const getSizeGuideUrls = () => {
    const mobileUrl = document.querySelector('[data-mobile-size-guide]')?.getAttribute('data-mobile-size-guide') || '';
    const desktopUrl = document.querySelector('[data-desktop-size-guide]')?.getAttribute('data-desktop-size-guide') || '';
    return { mobileUrl, desktopUrl };
  };
  
  // Add click handler to all size guide triggers
  const sizeGuideTriggers = document.querySelectorAll('[data-size-guide-trigger]');
  
  sizeGuideTriggers.forEach(trigger => {
    trigger.addEventListener('click', function(event) {
      event.preventDefault();
      
      const { mobileUrl, desktopUrl } = getSizeGuideUrls();
      const guideImageUrl = device === 'desktop' ? desktopUrl : mobileUrl;
      
      if (guideImageUrl && guideImageUrl.length > 0 && typeof Swal !== 'undefined') {
        Swal.fire({
          imageUrl: guideImageUrl,
          showCloseButton: true,
          showConfirmButton: false,
          width: device === 'desktop' ? 600 : '100%',
          imageWidth: device === 'desktop' ? 600 : '100%',
          padding: 0,
          animation: false,
        });
      }
    });
  });
});

// Add to Cart Button Text Management
document.addEventListener('DOMContentLoaded', function() {
  const userSelections = new Set(); // Track which variant options user has selected
  
  // Function to check if user has selected all required variants
  function hasUserSelectedAllVariants() {
    const variantSelector = document.querySelector('variant-radios, variant-selects');
    if (!variantSelector) return false;
    
    // Count total number of variant option groups (fieldsets for radios, selects for dropdowns)
    const totalVariantOptions = variantSelector.querySelectorAll('fieldset, .product-form__input').length;
    
    // Check if user has made a selection in each group
    return userSelections.size >= totalVariantOptions;
  }
  
  // Function to update Shop Pay button state
  function updateShopPayButton(hasSelectedAll) {
    // Use setTimeout to ensure Shop Pay button has rendered
    setTimeout(() => {
      const dynamicCheckoutWrapper = document.querySelector('.product__dynamic-checkout-buttons');
      if (dynamicCheckoutWrapper) {
        if (hasSelectedAll) {
          dynamicCheckoutWrapper.style.pointerEvents = 'auto';
          dynamicCheckoutWrapper.style.opacity = '1';
        } else {
          dynamicCheckoutWrapper.style.pointerEvents = 'none';
          dynamicCheckoutWrapper.style.opacity = '0.6';
        }
      }
    }, 100);
  }
  
  // Function to update button text and styling
  function updateAddToCartButtonText() {
    const allAddToCartButtons = document.querySelectorAll('.product-form__submit[data-add-to-cart-text]');
    const hasSelectedAll = hasUserSelectedAllVariants();
    
    allAddToCartButtons.forEach(button => {
      const buttonText = button.querySelector('span');
      if (!buttonText) return;
      
      const addToCartText = button.getAttribute('data-add-to-cart-text') || 'Add to Cart';
      const selectSizeText = button.getAttribute('data-select-size-text') || 'Select Size';
      
      if (hasSelectedAll) {
        // User has actively selected ALL required variants
        buttonText.textContent = addToCartText;
      } else {
        // Default state or incomplete selection
        buttonText.textContent = selectSizeText;
      }
    });
    
    // Update Shop Pay button state
    updateShopPayButton(hasSelectedAll);
  }
  
  // Listen for variant changes
  const variantSelectors = document.querySelectorAll('variant-radios, variant-selects');
  variantSelectors.forEach(selector => {
    selector.addEventListener('change', function(e) {
      // Track which fieldset/input group was changed
      const changedFieldset = e.target.closest('fieldset, .product-form__input');
      if (changedFieldset) {
        // Get a unique identifier for this variant option group
        const fieldsetIndex = Array.from(selector.querySelectorAll('fieldset, .product-form__input')).indexOf(changedFieldset);
        userSelections.add(fieldsetIndex);
      }
      updateAddToCartButtonText();
    });
  });
  
  // Initial state: Show "Select Size" with reduced opacity and disable Shop Pay
  updateAddToCartButtonText();
  
  // Watch for Shop Pay button rendering (it loads async)
  const observer = new MutationObserver(() => {
    updateShopPayButton(hasUserSelectedAllVariants());
  });
  
  const dynamicCheckoutWrapper = document.querySelector('.product__dynamic-checkout-buttons');
  if (dynamicCheckoutWrapper) {
    observer.observe(dynamicCheckoutWrapper, { childList: true, subtree: true });
  }
});

function getInstallmentModalTrigger() {
  const form = document.querySelector('form.installment');
  if (!form) return null;

  const roots = [form];
  const paymentTerms = form.querySelector('shopify-payment-terms');
  if (paymentTerms?.shadowRoot) roots.push(paymentTerms.shadowRoot);

  for (const root of roots) {
    const candidates = root.querySelectorAll('button, a, [role="button"]');
    for (const candidate of candidates) {
      const label = (candidate.textContent || candidate.getAttribute('aria-label') || '').trim().toLowerCase();
      if (label.includes('learn')) return candidate;
    }
    if (candidates.length) return candidates[0];
  }

  return null;
}

function isInstallmentFormTarget(target) {
  if (!target) return false;
  const form = document.querySelector('form.installment');
  if (!form) return false;
  if (target === form || form.contains(target)) return true;

  const paymentTerms = form.querySelector('shopify-payment-terms');
  return Boolean(paymentTerms && (target === paymentTerms || paymentTerms.contains?.(target)));
}

let installmentModalScrollY = null;
let installmentModalOpener = null;
let suppressInstallmentFocusRestore = false;

function waitForInstallmentModalTrigger(timeout = 5000) {
  return new Promise((resolve) => {
    let settled = false;
    const observers = [];
    let poll;
    let timer;

    const done = (value) => {
      if (settled) return;
      settled = true;
      window.clearTimeout(timer);
      window.clearInterval(poll);
      observers.forEach((observer) => observer.disconnect());
      resolve(value || null);
    };

    const existing = getInstallmentModalTrigger();
    if (existing) {
      done(existing);
      return;
    }

    const form = document.querySelector('form.installment');
    const paymentTerms = form?.querySelector('shopify-payment-terms');
    if (!paymentTerms) {
      done(null);
      return;
    }

    const observeTargets = [form];
    if (paymentTerms.shadowRoot) observeTargets.push(paymentTerms.shadowRoot);

    observeTargets.forEach((target) => {
      const observer = new MutationObserver(() => {
        const trigger = getInstallmentModalTrigger();
        if (trigger) done(trigger);
      });
      observer.observe(target, { childList: true, subtree: true, attributes: true });
      observers.push(observer);
    });

    poll = window.setInterval(() => {
      const trigger = getInstallmentModalTrigger();
      if (trigger) done(trigger);
    }, 100);

    timer = window.setTimeout(() => done(getInstallmentModalTrigger()), timeout);
  });
}

function openInstallmentDrawerFallback(trigger) {
  const drawerId = trigger.getAttribute('data-installment-drawer-id');
  if (drawerId && window.Woolman?.ModalsAndDrawers?.showModalOrDrawer) {
    Woolman.ModalsAndDrawers.showModalOrDrawer(drawerId);
    return true;
  }
  return false;
}

function restoreInstallmentModalFocus() {
  if (suppressInstallmentFocusRestore) return;
  const opener = installmentModalOpener || document.querySelector('[data-open-installment-modal]');
  if (opener) opener.focus({ preventScroll: true });
  if (installmentModalScrollY != null) {
    window.scrollTo(0, installmentModalScrollY);
  }
}

function keepInstallmentScroll() {
  restoreInstallmentModalFocus();
  requestAnimationFrame(restoreInstallmentModalFocus);
  setTimeout(restoreInstallmentModalFocus, 0);
  setTimeout(restoreInstallmentModalFocus, 50);
  setTimeout(restoreInstallmentModalFocus, 150);
}

document.addEventListener('click', async (event) => {
  const trigger = event.target.closest('[data-open-installment-modal]');
  if (!trigger) return;

  event.preventDefault();
  event.stopPropagation();

  installmentModalOpener = trigger;
  installmentModalScrollY = window.scrollY;

  const form = document.querySelector('form.installment');
  const paymentTerms = form?.querySelector('shopify-payment-terms');

  // Prefer Shopify's Installments modal when shopify-payment-terms is present
  // (native for GBP, or synthesized fallback for US/CA). Otherwise open the drawer.
  if (!paymentTerms) {
    openInstallmentDrawerFallback(trigger);
    return;
  }

  suppressInstallmentFocusRestore = true;
  const shopifyTrigger = await waitForInstallmentModalTrigger();

  if (!shopifyTrigger) {
    suppressInstallmentFocusRestore = false;
    openInstallmentDrawerFallback(trigger);
    return;
  }

  shopifyTrigger.click();

  window.setTimeout(() => {
    suppressInstallmentFocusRestore = false;
  }, 600);
});

document.addEventListener('focusin', (event) => {
  if (suppressInstallmentFocusRestore) return;
  if (!isInstallmentFormTarget(event.target)) return;
  // Modal close restores focus to the hidden banner — keep scroll position.
  keepInstallmentScroll();
});
